<template>
  <div class="ls_spin_container">
    <Row :gutter="24" type="flex">

      <Col :xs="24" :sm="24" :md="12" :lg="8"  class="mb-24">
        <Button
          class="card-container"
          :to="{ name: item_type + '_create' }"
        >
          <img src="/static/svg/user_add.svg" alt="" class="user-img__desktop">

          <div class="d-flex align-center">
            <div>Добавить сотрудника</div>
            <img src="/static/svg/add_user_mobile.svg" alt="" class="user-img__mobile">
          </div>

        </Button>
      </Col>

      <Col :xs="24" :sm="24" :md="12" :lg="8" v-for="el of data" :key="el.id" class="mb-24">
        <Card class="card-container">

          <Row type="flex" :gutter="24" style="flex-wrap: nowrap">
            <Col>
              <img v-if="el.image_url"
                   :src="imgUrl + el.image_url" alt="" class="user-img"
                   @click="$router.push({
                    name: item_type + '_detail',
                    params: { id: el.id }
                  })
                ">
              <img v-else
                   src="/static/img/user_avatar_60x60.png" alt="" class="user-img"
                   @click="$router.push({
                    name: item_type + '_detail',
                    params: { id: el.id }
                  })
                ">
            </Col>
            <Col>
              <Tag color="success">{{
                el.role_display
                }}
              </Tag>

              <h2
                class="item_card_header mb-15"
                @click="
                  $router.push({
                    name: item_type + '_detail',
                    params: { id: el.id }
                  })
                "
              >
                {{ el.full_name }}
                <!--<Tag color="green" style="float: right;">{{ el.role_display }}</Tag>-->
              </h2>

              <div class="item_card_content">
                <p class="fs-15 color-grey mb-5">
                  Создан
                  {{ formatDateTime(el.created_date) }}
                </p>
                <p v-if="el.phone" class="fs-15">
                  <a :href="'tel:' + el.phone" style="color: #5087DE; text-decoration: underline">{{ el.phone }}</a>
                </p>
              </div>
            </Col>

            <Row class="item_actions" type="flex" justify="end" align="middle">
              <Button v-if="el.id !== current_user_id && display_delete_button_by_item(el)"
                      style="color: #EF6E57; border: none; box-shadow: none; padding: 0; margin-right: 8px"
                      @click="removeModal = true, removeId = el.id">
                <Icon type="md-trash" size="24"/>

              </Button>

              <Button
                v-if="display_edit_button_by_item(el)"
                type="info"
                class="btn-edit__user"
                @click="
                  $router.push({
                    name: item_type + '_edit',
                    params: { id: el.id }
                  })
                "
              >
                <Icon type="md-create" size="24"/>

              </Button>

            </Row>
          </Row>


        </Card>
      </Col>
    </Row>
    <userItem
      :id="item.id"
      :action="item.action"
      v-model="item.show"
      @reload-table="fetchItems"
      :base_view_url="baseViewUrl"
      :item_type="item_type"
    ></userItem>


    <!--Modal for remove Item-->
    <Modal
      :footer-hide="footerHide"
      v-model="removeModal"
      title="">

      <h3 class="mb-40">Вы действительно хотите удалить данного пользователя?</h3>

      <Row type="flex" justify="center">
        <Button type="error" @click="removeModal = false">Отмена</Button>
        <Button type="success" style="margin-left: 12px"
                @click="deleteItem(removeId)">
          Удалить
        </Button>
      </Row>
    </Modal>


    <Spin size="large" fix v-if="loading"></Spin>
  </div>
</template>

<script>
    import {base_url, server_addr} from "../../http.js";
    import userItem from "@/apps/user/userItem.vue";
    import cardColumn from "@/components/core/cardColumn.vue";

    import {BaseCardListData} from "../../base/base_card_list.js";

    let _app = BaseCardListData();
    _app.components = {
        userItem,
        cardColumn
    };

    _app.data = function () {
        return {
            // Base settings
            baseViewUrl: base_url + "/users/",
            item_type: "user",
            loading: true,

            data: [],
            imgUrl: server_addr,

            item: {
                show: false,
                id: null,
                action: null
            },
            removeModal: false,
            footerHide: true,
            removeId: null
        };
    };
    _app.methods.display_edit_button_by_item = function (item) {
        if ('can_update' in item) {
            return (item.can_update && (
                this.permissions.indexOf("user.user_update_all") !== -1 ||
                this.permissions.indexOf("user.user_update_owner") !== -1
            ));
        }
        return (
            this.permissions.indexOf("user.user_update_all") !== -1 ||
            this.permissions.indexOf("user.user_update_owner") !== -1
        );
    };
    _app.methods.display_delete_button_by_item = function (item) {
        if ('can_delete' in item) {
            return (item.can_delete && (
                this.permissions.indexOf("user.user_delete_all") !== -1 ||
                this.permissions.indexOf("user.user_delete_owner") !== -1
            ));
        }
        return (
            this.permissions.indexOf("user.user_delete_all") !== -1 ||
            this.permissions.indexOf("user.user_delete_owner") !== -1
        );
    };
    _app.computed.display_create_button = function () {
        return (
            this.permissions.indexOf("user.user_create") !== -1
        );
    };

    export default _app;
</script>

<style scoped>
  a.card-container {
    width: 100%;
    height: 100%;
    font-size: 20px;
    background-color: #E0E0E0;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }

  a.card-container .user-img__mobile {
    display: none;
  }

  .card-container .ivu-tag {
    padding: 0;
  }

  .user-img {
    width: 110px;
    height: 110px;
    border-radius: 50%;
  }

  a.card-container:hover {
    border: none;
    color: #747b8b;
  }

  .item_actions {
    position: absolute;
    right: 10px;
    bottom: 10px;
  }

  .btn-edit__user {
    border-radius: 50%;
    width: 48px;
    height: 48px;
    padding: 0;
    display: flex;
    align-items: center;
    justify-content: center
  }

  @media screen and (max-width: 1900px) {
    .user-img {
      width: 90px;
      height: 90px;
    }
  }


  @media screen and (max-width: 1500px) {
    .item_actions {
      right: 5px;
      bottom: 5px;
    }

    .card-container  {
      padding-bottom: 15px;
    }

    .user-img {
      width: 70px;
      height: 70px;
    }

    .btn-edit__user {
      width: 36px;
      height: 36px;
    }
  }

  @media screen and (max-width: 767px) {
    .card-container h2 {
      margin-bottom: 5px;
    }

    a.card-container {
      font-size: 16px;
      background-color: #5087DE;
      color: #ffffff
    }

    a.card-container span {
      display: flex;
    }

    a.card-container .user-img__mobile {
      display: block;
      margin-left: 24px;
    }

    a.card-container .user-img__desktop {
      display: none;
    }


  }

  @media screen and (max-width: 575px) {
    .card-container p, .card-container a {
      font-size: 12px;
    }


  }

</style>



// WEBPACK FOOTER //
// src/apps/user/user.vue